/** Do not let the SDK serialize arbitrary rejected objects (HTTP bodies, tokens). */
export const normalizeException = (error: unknown): Error => {
  if (error instanceof Error) return error
  if (typeof error === 'string') return new Error(error)
  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return new Error(error.message)
  }
  return new Error(
    `Non-Error value thrown (${error === null ? 'null' : typeof error})`,
  )
}
